import { useEffect } from "react";

const SITE = "https://musicflowstudioai.com";
const DEFAULT_TITLE = "MusicFlow StudioAi — AI Soundtrack Engine for Games";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

// Per-route document <title>, description, canonical and robots (Google renders the SPA; the static index.html holds the defaults).
export function useSeo({ title, description, path, noindex = false, jsonLd = null } = {}) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    document.title = title ? `${title} · MusicFlow StudioAi` : DEFAULT_TITLE;
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); }
    setMeta("property", "og:title", title ? `${title} · MusicFlow StudioAi` : DEFAULT_TITLE);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical && path !== undefined) canonical.setAttribute("href", `${SITE}${path}`);
    if (path !== undefined) setMeta("property", "og:url", `${SITE}${path}`);
    let script = document.getElementById("route-jsonld");
    if (ld) {
      if (!script) { script = document.createElement("script"); script.id = "route-jsonld"; script.type = "application/ld+json"; document.head.appendChild(script); }
      script.textContent = ld;
    } else if (script) script.remove();
  }, [title, description, path, noindex, ld]);
}
